import { createClient } from "@supabase/supabase-js";
import type { Database } from "@/types/database";

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!url || !key) {
  throw new Error(
    "Variáveis Supabase em falta. Configura VITE_SUPABASE_URL e VITE_SUPABASE_PUBLISHABLE_KEY no .env.local",
  );
}

export const supabase = createClient<Database>(url, key, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: "pkce",
    // Passkey (WebAuthn) opt-in. Requer @supabase/supabase-js >= 2.105
    // e activação no projecto em Authentication → Passkeys.
    experimental: { passkey: true },
  },
  global: {
    headers: {
      "X-Client-Info": "uhdp-evora-web",
    },
  },
});
